import { useMemo } from "react";

export const useAllProducts = (productsByPages) => {
	return useMemo(() => {
		return Object.entries(productsByPages).flatMap(
			([_pageNumber, products]) => products
		);
	}, [productsByPages]);
};
